import React, { FunctionComponent, useContext, useEffect, useState } from 'react';
import { Link, useLocation } from "react-router-dom";
import styles from "./Common.module.scss";
import { data } from './local';
import { Typography, Container,  Grid, Button} from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getViaSupportGroupEmail } from './services';

const Faq: FunctionComponent<any> = ({ token }: any) => {
     const languageSelected:any = useSelector((state:any) => state.lang);
    const languageData: any = data;
    const { Faq } = languageData[languageSelected];

    const handleClick = async () => {
        let mailLink: string | undefined;
        await getViaSupportGroupEmail().then((response: any[]) => {
            mailLink = `mailto:` + response[0] + Faq.contact +  response[1];
        });
        window.open(mailLink, '_blank');
    };

    let history = useHistory();

    function handleFaq() {
        history.push("faqDetails", {})
    }
 
    return (
        <Container maxWidth={"xl"} className={styles.FaqSection}>
            <div >
                <Typography className={styles.FaqTitle} >{Faq.title}</Typography>
                <Typography className={styles.FaqSubTitle} >{Faq.subtitle} <Link onClick={handleClick} > {Faq.link}</Link></Typography>
                <Grid container justify="center" alignItems="center" >
                    <Button variant="outlined" onClick={handleFaq} className={styles.FaqButton}>{Faq.viewFaqBttn}</Button>
                </Grid>
            </div>
        </Container>
    )
}

export default Faq;